import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './styles/globals.css';

// Sprint 10.3.C — axe-core in dev mode. Logs WCAG violations to the
// browser console with a 1s debounce. The `import.meta.env.DEV` guard
// dead-codes the call site in prod; `/* @vite-ignore */` keeps Rollup
// from pre-bundling axe-core into an orphan chunk in the prod build.
if (import.meta.env.DEV) {
  const axeModule = '@axe-core/react';
  void import(/* @vite-ignore */ axeModule).then(({ default: axe }) => {
    axe(React, ReactDOM, 1000);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
